export enum LocalStorageConstants {
  LANGUAGE = "app.language",
  FEATURE_TOUR_MY_SERVICES_COMPLETED = "lazo_feature_tour_v1",
  FEATURE_TOUR_WORKFLOW_DETAIL_PENDING = "lazo_feature_tour_workflow_detail_v1",
  FEATURE_TOUR_INBOX_COMPLETED = "lazo_feature_tour_inbox_v1",
}
